module.exports = __webpack_public_path__ + "static/mujeres003-4b6800d845480d8d9f2f1523c0e01a88.jpg";